export const HOVER_ITEM_COLOR = '#3b455e';
export const HEADER_BG_COLOR = 'transparent';
export const BLACK = '#17202A';
export const WHITE = '#FFFFFF';
export const DARK_BLUE = '#475C93';
export const MAIN_COLOR = '#817655';
export const COMPLEMENTARY_MAIN_COLOR = '#556081';
export const DARK_GREEN = '#768155';
export const MAROON = '#816055'